import { createSlice } from "@reduxjs/toolkit";
import { getS3List, getUploadURL } from "../../services/s3";
import { query } from "../../services/object";
export const homeSlice = createSlice({
  // Slice name, this should be always as page name.
  name: "home",

  // Initial state for the slice
  initialState: {
    data: {},
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },

  // Reducers will mutate the state, put all the state mutation method over here
  reducers: {
    initialize: (state, action) => {
      state.data = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
    error: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    loading: (state, action) => {
      state.status = action.payload ? "loading" : "succeeded";
    },
    initialLoading: (state, action) => {
      state.status = action.payload ? "initalLoading" : "succeeded";
    },
  },
});

export default homeSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } = homeSlice.actions;

// Public Selectors
export const selectHomeData = (state) => state.home.data;
export const selectHomeStatus = (state) => state.home.status;
export const selectHomeError = (state) => state.home.error;

export const initializeAsync = (params) => async (dispatch) => {
  dispatch(initialLoading(true));


  let arts = await query("art","getAllArtRecords");
  if (arts.isSuccess) {
    dispatch(initialize({ records: arts.data }));
  }

  /*let images = await query("art","getAllRecords");
  console.log(JSON.stringify(images.data));
  if (images.isSuccess) {
    let param = { name: images.data[0].name, type: "jpeg" };
    getUploadURL(param).then((result) => {
      if (result.isSuccess) {
        dispatch(initialize({records: result.data}));
      }
    });
    dispatch(initialize({ contacts: images.data }));
  } else {
    dispatch(initialize({}));
  }
  getS3List().then((result) => {
    console.log("Result : ", result.data);
    console.log("Result : ", result.data.Contents[0].Key);
    let param = { name: result.data.Contents[0].Key, type: "jpg" };
    getUploadURL(param).then((result) => {
      if (result.isSuccess) {
        dispatch(initialize({records: result.data}));
      }
    });
  });*/
};
